export default{
	 lang:{
		 title: 'Vehicle Wiring Diagram Inquiry',
		 brand: "Brand",
		 language: "Language",
		 carName: "Vehicle",
		 searchMC: "System Name",
		 searchMS: "System Description",
		 jumper: "jumperID",
		 buuton1: "Search",
		 desOption:['Battery Pack Inspection','Compressor On The Vehicle','Compressor Under The Vehicle'],
		 report:{
			 shebei1: 'Provided by',
			 shebei2: 'testing equipment',
			oneTitle: 'Test Result',
			ver: 'License plate not set',
			vin: 'VIN',
			bianhao: 'Report No',
			jcTime: 'Test Time',
			bms: 'BMS Test Result',
			tips: 'Tip',
			tipText: '"Not supported" means that battery pack detection does not support reading this data item.You may try selecting BMS (Battery Management System) under full-vehicle diagnosis to read and view data streams.',
			soc: 'State of Charge (SOC)',
			soh: 'State of Health (SOH)',
			Vname1: 'Total Voltage',
			Vname2: 'Battery Charge-Discharge Cycles',
			Vname3: 'Max Cell Voltage',
			Vname4: 'Max Cell Temperature',
			Vname5: 'Min Cell Voltage',
			Vname6: 'Min Cell Temperature',
			Vname7: 'Voltage Diff',
			Vname8: 'Insulation Resistance',
			bms: 'BMS Test Details',
			tab1: 'Test Item',
			tab2: 'Test Result',
			tab3: 'Unit',
			dtdy: 'Cell Voltage',
			max: 'Max',
			min: 'Min',
			dcwd: 'Cell Temperature',
			shengcheng: 'Generate PDF',
			jcsb: 'Test Device',
			sbbh: 'Device No',
		 }
	 }
}